import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import QuoteWizard from "@/pages/QuoteWizard";
import { ForgotPasswordPage, LoginPage, RegisterPage, ResetPasswordPage } from "@/pages/AuthPages";
import Dashboard from "@/pages/Dashboard";
import PolicyDetail from "@/pages/PolicyDetail";
import Certificate from "@/pages/Certificate";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import Admin from "@/pages/Admin";
import { AssistantWidget } from "@/components/AssistantWidget";

const Layout = () => (
  <div className="flex min-h-screen flex-col">
    <SiteHeader />
    <main className="flex-1">
      <Outlet />
    </main>
    <SiteFooter />
  </div>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/quote" element={<QuoteWizard />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/policies/:id" element={<ProtectedRoute><PolicyDetail /></ProtectedRoute>} />
              <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
              <Route path="*" element={<div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="not-found"><h1 className="text-2xl font-extrabold">Page not found</h1><a href="/" className="mt-4 inline-block text-blue-700 underline">Go to the home page</a></div>} />
            </Route>
            <Route path="/policies/:id/certificate" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
          </Routes>
          <AssistantWidget />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
